import moment from 'moment';

export const documentoElectronico = {
  Clave: '',
  CodigoActividad: '',
  NumeroConsecutivo: '',
  FechaEmision: moment().format('YYYY-MM-DD HH:mm'),
  Emisor: {
    Id: 0,
    Nombre: '',
    Identificacion: {
      Tipo: '',
      Numero: ''
    },
    NombreComercial: null,
    Ubicacion: {
      Provincia: '',
      Canton: '',
      Distrito: '',
      Barrio: '',
      OtrasSenas: ''
    },
    Telefono: {
      CodigoPais: '',
      NumTelefono: ''
    },
    CorreoElectronico: '',
    AplicacionId: 0
  },
  Receptor: {
    EmisorId: 0,
    IdentificacionExtranjero: '',
    OtrasSenasExtranjero: '',
    Id: 0,
    Nombre: '',
    Identificacion: {
      Tipo: '01',
      Numero: ''
    },
    NombreComercial: null,
    Ubicacion: null,
    Telefono: null,
    CorreoElectronico: '',
  },
  CondicionVenta: '01',
  PlazoCredito: '0',
  MedioPago: '01',
  DetalleServicio: {
    LineaDetalle: []
  },
  OtrosCargosPorDocumento: null,
  ResumenFactura: {
    CodigoTipoMoneda: {
      CodigoMoneda: 'CRC',
      TipoCambio: 1
    },
    TotalServGravados: 0,
    TotalServExentos: 0,
    TotalServExonerado: 0,
    TotalMercanciasGravadas: 0,
    TotalMercanciasExentas: 0,
    TotalMercExonerada: 0,
    TotalGravado: 0,
    TotalExento: 0,
    TotalExonerado: 0,
    TotalVenta: 0,
    TotalDescuentos: 0,
    TotalVentaNeta: 0,
    TotalImpuesto: 0,
    TotalIvaDevuelto: 0,
    TotalOtrosCargos: 0,
    TotalComprobante: 0
  },
  InformacionReferencia: null,
  Normativa: {
    NumeroResolucion: '',
    FechaResolucion: ''
  },
  DocumentoFirmado: '',
  SituacionDocumento: '',
  Otros: null
};